import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import { initBrowserCompat } from './utils/browserCompat'
import { performSecurityCheck } from '@/utils/secureStorage'
import { captureAttribution } from '@/utils/attribution'
import { captureLeadCode } from '@/utils/leadOffer'

import './style.css'
import './styles/browser-fixes.css'

// Initialize browser compatibility features
initBrowserCompat()

// Perform security check on application startup
performSecurityCheck()

// Campagne-attributie: utm_* van de landings-URL (doorgegeven door boenkop.be)
// bewaren voor deze browsersessie, zodat ze bij de boeking meegaan.
captureAttribution()
// Kortingscode uit de kortingsmail (?code=): bewaren voor de hero en de betaalpagina.
captureLeadCode()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')

// PWA: registreer de service worker (alleen in productie; in dev zou hij de
// Vite-modules cachen en hot reload breken)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Niet-fataal: zonder service worker werkt het portaal gewoon als website
    })
  })
}